var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"not-found"},[(_vm.allBots.length)?_c('list-all-bots',{on:{"updated":function($event){return _vm.setAllBots()}}}):_vm._e(),(!_vm.allBots.length)?_c('empty-view',{attrs:{"message":"Bot não encontrado!"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }